module.exports = __webpack_public_path__ + "static/media/icViews.a7be072b.svg";